import { render, staticRenderFns } from "./ShopListItem.vue?vue&type=template&id=b5473f18&"
import script from "./ShopListItem.vue?vue&type=script&lang=js&"
export * from "./ShopListItem.vue?vue&type=script&lang=js&"
import style0 from "./ShopListItem.vue?vue&type=style&index=0&scop=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports